import { fakerEN as faker } from "@faker-js/faker";
import { NodeSummary } from "./query";

const generateAvatars = (n: number) => {
    const avatars = [];

    for (let i = 0; i < n; i++) {
        avatars.push(faker.image.avatar());
    }

    return avatars;
}

export const generateCompanies = (n: number) => {
    const companies = [];

    for (let i = 0; i < n; i++) {
        companies.push({
            id: (i + 1).toString(),
            name: faker.company.name(),
            note: faker.lorem.paragraphs(1),
        });
    }

    return companies;
}

export const generatePeople = (n: number) => {
    const people = [];

    for (let i = 0; i < n; i++) {
        people.push({
            id: (i + 1).toString(),
            name: faker.person.fullName(),
            subtitle: faker.person.jobTitle(),
            avatars: generateAvatars(faker.helpers.rangeToNumber({ min: 1, max: 4 })),
            description: faker.lorem.paragraphs(1),
        });
    }

    return people;
}


const generatePersonNode = (i: number): NodeSummary => {
    return {
        id: (i + 1).toString(),
        circleId: '1',
        type: 'person',
        name: faker.person.fullName(),
        subtitle: faker.person.jobTitle(),
        description: faker.lorem.paragraphs(1),
        tags: faker.helpers.arrayElements(['tag1', 'tag2', 'tag3'], { min: 1, max: 3 }),
        avatars: generateAvatars(1),
        lastUpdated: faker.date.recent().toISOString(),
        timestamp: faker.date.recent().toISOString()
    };
}

const generateGroupNode = (i: number, peopleNodes: NodeSummary[]): NodeSummary => {
    const groupSize = randomNum(1, 5);
    const people = faker.helpers.shuffle(peopleNodes).slice(0, groupSize);
    return {
        id: (i + 1).toString(),
        circleId: '1',
        type: 'group',
        name: faker.company.name(),
        subtitle: faker.company.catchPhrase(),
        description: faker.lorem.paragraphs(1),
        tags: faker.helpers.arrayElements(['tag1', 'tag2', 'tag3'], { min: 1, max: 3 }),
        avatars: people.map((person: NodeSummary) => person.avatars[0]),
        lastUpdated: faker.date.recent().toISOString(),
        timestamp: faker.date.recent().toISOString()
    };
}

const generateEntityNode = (i: number): NodeSummary => {
    return {
        id: (i + 1).toString(),
        circleId: '1',
        type: 'entity',
        name: faker.internet.displayName(),
        subtitle: faker.internet.domainName(),
        description: faker.lorem.paragraphs(1),
        tags: faker.helpers.arrayElements(['tag1', 'tag2', 'tag3'], { min: 1, max: 3 }),
        avatars: generateAvatars(1),
        lastUpdated: faker.date.recent().toISOString(),
        timestamp: faker.date.recent().toISOString()
    };
}

const generateEventNode = (i: number): NodeSummary => {
    return {
        id: (i + 1).toString(),
        circleId: '1',
        type: 'effort',
        name: faker.location.city(),
        subtitle: faker.location.streetAddress(),
        description: faker.lorem.paragraphs(1),
        tags: faker.helpers.arrayElements(['tag1', 'tag2', 'tag3'], { min: 1, max: 3 }),
        avatars: generateAvatars(1),
        lastUpdated: faker.date.recent().toISOString(),
        timestamp: faker.date.recent().toISOString()
    };
}

export const generateNodes = (n: number) => {
    const nodes = [];

    for (let i = 0; i < n; i++) {
        const randomType = selectRandomType();
        let newNode;
        const peopleNodes = nodes.filter((node) => node.type === 'person');
        const numOfPeopleType = peopleNodes.length;
        // If there are no people and it wants a group, create a person instead
        if (randomType === 'person' || (randomType === 'group' && numOfPeopleType === 0) ) {
            newNode = generatePersonNode(i);
        } else if (randomType === 'group') {
            newNode = generateGroupNode(i, peopleNodes);

        } else if (randomType === 'entity') {
            newNode = generateEntityNode(i);
        // Last is event type
        } else {
            newNode = generateEventNode(i);
        }
        nodes.push(newNode);
    }

    return nodes;
}


const selectRandomType = () => {
    return faker.helpers.arrayElement(['person', 'group', 'entity', 'effort']);
}


export const generateKnots = (nodeId: string, n: number) => {
    const knotes = [];

    for (let i = 0; i < n; i++) {
        knotes.push({
            id: `${nodeId}-${i + 1}`,
            circleId: '1',
            nodeId: nodeId,
            type: 'note',
            title: faker.lorem.sentence(),
            description: faker.lorem.paragraphs(1),
            tags: faker.helpers.arrayElements(['tag1', 'tag2', 'tag3'], { min: 0, max: 3 }),
            timestamp: faker.date.recent().toISOString(),
        });
    }

    return knotes;
}


export const sleep = (ms: number) => new Promise((resolve) => setTimeout(resolve, ms));    

export const randomNum = (min: number, max: number) => Math.floor(Math.random() * (max - min + 1)) + min;
